var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"topup-codes"},[_c('topup-codes-breadcrumbs'),(_vm.isCurrentStep(1))?_c('topup-codes-step1'):_vm._e(),(_vm.isCurrentStep(2))?_c('topup-codes-step2'):_vm._e(),(_vm.isCurrentStep(3))?_c('topup-codes-step3'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }